import { render } from "./PaperToggle.vue?vue&type=template&id=477a5eb7"
import script from "./PaperToggle.vue?vue&type=script&lang=js"
export * from "./PaperToggle.vue?vue&type=script&lang=js"
script.render = render

export default script